import { useTranslation } from "react-i18next";

import { Button } from "../../../../components/Button";
import { EmptyIcon } from "./icons/Empty";
import { Container } from "./styles";

type Props = {
  onCreate: () => void;
  /** Another screen's texts (e.g. Keepo Links); the Keepos' ones when left out. */
  title?: string;
  description?: string;
  action?: string;
};

export const EmptyState = ({ onCreate, title, description, action }: Props) => {
  const { t } = useTranslation();
  return (
    <Container>
      <div className="image">
        <EmptyIcon />
      </div>
      <div className="text">
        <h3>{title ?? t("pages.sites.emptyState.title")}</h3>
        <p>{description ?? t("pages.sites.emptyState.description")}</p>
      </div>
      {/* Button is a div: a button for the keyboard and screen readers too */}
      <Button
        type="INFO"
        size="MD"
        className="cta"
        role="button"
        tabIndex={0}
        onClick={onCreate}
        onKeyDown={event => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onCreate();
          }
        }}>
        {action ?? t("pages.sites.actions.createNew.button.title")}
      </Button>
    </Container>
  );
};
